import { withI18n } from 'react-i18next';
import InvoiceToPay from './InvoiceToPay';

export const pureComponent = InvoiceToPay;
export default withI18n()(InvoiceToPay);
